import useMultipleLinkedInputs, { LinkedInput } from './useMultipleLinkedInputs';

const useLinkedInput = (linkedInput: LinkedInput) => useMultipleLinkedInputs([linkedInput]);

export default useLinkedInput;
